/** Mocks — pedidos prontos para carregamento (substituir por API depois) */
export const PEDIDOS_PRONTOS_MOCK = [
  {
    id: "PED-24081",
    numero: "24081",
    cliente: "Posto Sol Nascente Ltda",
    codigoCliente: "000145",
    loja: "01",
    cidade: "Cuiabá — MT",
    dataPedido: "2026-08-03",
    status: "pronto",
    placaSugerida: "ABC1D23",
    motoristaSugerido: "Carlos Mendes",
    volumeTotal: 28000,
    itens: [
      {
        codigo: "prod-s10",
        descricao: "Diesel S10",
        volume: 18000,
        um: "L",
      },
      {
        codigo: "prod-s500",
        descricao: "Diesel S500",
        volume: 10000,
        um: "L",
      },
    ],
  },
  {
    id: "PED-24082",
    numero: "24082",
    cliente: "Transportadora Horizonte",
    codigoCliente: "000288",
    loja: "01",
    cidade: "Várzea Grande — MT",
    dataPedido: "2026-08-03",
    status: "pronto",
    placaSugerida: "QWE4R56",
    motoristaSugerido: "Ana Paula Rocha",
    volumeTotal: 15000,
    itens: [
      {
        codigo: "prod-gasolina",
        descricao: "Gasolina Comum",
        volume: 15000,
        um: "L",
      },
    ],
  },
  {
    id: "PED-24079",
    numero: "24079",
    cliente: "Auto Posto Centro",
    codigoCliente: "000091",
    loja: "02",
    cidade: "Rondonópolis — MT",
    dataPedido: "2026-08-02",
    status: "pronto",
    placaSugerida: "",
    motoristaSugerido: "",
    volumeTotal: 32000,
    itens: [
      {
        codigo: "prod-s10",
        descricao: "Diesel S10",
        volume: 20000,
        um: "L",
      },
      {
        codigo: "prod-etanol",
        descricao: "Etanol Hidratado",
        volume: 12000,
        um: "L",
      },
    ],
  },
  {
    id: "PED-24075",
    numero: "24075",
    cliente: "Distribuidora Norte Combustíveis",
    codigoCliente: "000512",
    loja: "01",
    cidade: "Sinop — MT",
    dataPedido: "2026-08-02",
    status: "aguardando",
    placaSugerida: "XYZ9A87",
    motoristaSugerido: "Roberto Lima",
    volumeTotal: 10000,
    itens: [
      {
        codigo: "prod-s10",
        descricao: "Diesel S10",
        volume: 10000,
        um: "L",
      },
    ],
  },
];
